import { Factory } from "@/data/dao/Factory";
import { CatalogDao } from "@/data/dao/service/CatalogDao";
import type { IOfferSchedule } from "@/data/model/OfferSchedule";
import { Format } from "@/data/util/Format";

import { BaseTabbedController } from "@/portal/controller/BaseTabbedController";
import { OfferScheduleForm } from "@/portal/forms/OfferScheduleForm";
import { TastierGlobal } from "@/portal/globalAccess";
import {UiNotification} from "@/portal/ui/Notification";
import {i18n} from "@/portal/Trans";

export class OfferScheduleController extends BaseTabbedController<IOfferSchedule> {
    private offerScheduleForm: OfferScheduleForm;

    constructor(element: JQuery) {
        super(element, Factory.getInstance<CatalogDao>(CatalogDao).offerScheduleDataSource);

        this.offerScheduleForm = new OfferScheduleForm(this.formContentByTabName("offerscheduleedit"));
        this.registerModelForm(this.offerScheduleForm);
    }

    protected onModelLoaded(m?: IOfferSchedule) {
        if (this.copyEntityId != null) {
            UiNotification.showSuccess(i18n("offerSchedule.offerScheduleCopiedAndEditingNow"))
        }
        
        if (m === undefined) {
            const vw = $("#kt_header > #kt_header_menu_wrapper");
            if (vw.find("> .selectedlocation").length === 0)
                vw.append(
                    '<div class="selectedlocation">' +
                        Format.htmlEscape(TastierGlobal.getLocationSwitch()!.getCurrentLocationName()) +
                        "</div>"
                );
        }

        this.offerScheduleForm.setData(m);
    }
}
